const italyDevUrl =
  "https://data-tracking-api-italy-master-dot-mobs-2019-ncov-web.appspot.com/";

export { italyDevUrl };
